import React, { useState } from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { authAxios, apiErrorMessage } from '@/lib/api';

const LABEL_CLS = 'text-[10px] uppercase tracking-wider text-amber-700/60 font-sans font-semibold mb-1 block';
const INPUT_CLS = 'w-full border border-amber-200 rounded-md px-3 py-2.5 text-sm font-sans text-earth-dark focus:ring-2 focus:ring-amber-300 focus:outline-none bg-white';

export default function AIBlogPanel({ onGenerated }) {
  const [topic, setTopic] = useState('');
  const [keywords, setKeywords] = useState('');
  const [generating, setGenerating] = useState(false);

  const generate = async () => {
    if (!topic.trim()) return;
    setGenerating(true);
    try {
      const list = keywords.split(',').map(k => k.trim()).filter(Boolean);
      const { data } = await authAxios.post('/api/ai/generate-blog', { topic, keywords: list });
      onGenerated(data);
    } catch (e) {
      alert('AI generation failed: ' + apiErrorMessage(e));
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4 space-y-3" data-testid="ai-blog-panel">
      <div className="flex items-center gap-2 mb-1">
        <Sparkles size={14} className="text-amber-600" />
        <p className="text-xs font-sans font-semibold text-amber-800">AI Blog Generator</p>
      </div>
      <div>
        <label className={LABEL_CLS}>Blog Topic</label>
        <input value={topic} onChange={(e) => setTopic(e.target.value)} placeholder="e.g. Benefits of Indian turmeric for UAE importers" className={INPUT_CLS} data-testid="ai-blog-topic" />
      </div>
      <div>
        <label className={LABEL_CLS}>Target Keywords (comma-separated, optional)</label>
        <input value={keywords} onChange={(e) => setKeywords(e.target.value)} placeholder="e.g. turmeric exporter, Indian spices, bulk turmeric" className={INPUT_CLS} data-testid="ai-blog-keywords" />
      </div>
      <button
        onClick={generate}
        disabled={generating || !topic.trim()}
        className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white font-sans font-semibold text-sm py-2.5 rounded-md hover:from-amber-600 hover:to-orange-600 transition-all flex items-center justify-center gap-2 disabled:opacity-50 shadow-sm"
        data-testid="ai-blog-generate"
      >
        {generating ? <><Loader2 size={14} className="animate-spin" /> Generating...</> : <><Sparkles size={14} /> Generate Blog Post</>}
      </button>
      <p className="text-[10px] text-amber-600/60 font-sans text-center">AI will generate title, content, excerpt, and tags. You can edit everything after.</p>
    </div>
  );
}
